<nav class="kontenrahmen-sub-nav" mat-tab-nav-bar>
    <a
        *ngIf="isTabMenuVisible('/finanzen/kontenrahmen')"
        mat-tab-link
        [routerLink]="['/finanzen/kontenrahmen']"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive
        #krla="routerLinkActive"
        [active]="krla.isActive"
        >Kontenrahmen</a
    >
    <a
        *ngIf="isTabMenuVisible('/finanzen/honorar-tieraerzte')"
        mat-tab-link
        [routerLink]="['/finanzen/kontenrahmen/honorar-tieraerzte']"
        routerLinkActive
        #htla="routerLinkActive"
        [active]="htla.isActive"
        >Honorar-TAs</a
    >
    <a
        *ngIf="isTabMenuVisible('/finanzen/fahrzeuge')"
        mat-tab-link
        [routerLink]="['/finanzen/kontenrahmen/fahrzeuge']"
        routerLinkActive
        #fzla="routerLinkActive"
        [active]="fzla.isActive"
        >Fahrzeuge</a
    >
</nav>
<router-outlet></router-outlet>
